import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';

import { LBL_UNDO_DELETE, LBL_EDIT_TIMESHEET,LBL_OK, LBL_DELETE, LBL_YES, LBL_SAVE, LBL_UPDATE_QUOTE, LBL_APPROVE, LBL_ADD_ANOTHER_SHIFT, LBL_APPROVE_OT, LBL_NO, LBL_CANCEL, LBL_CROP, LBL_ACCEPT_QUOTE, LBL_SHIFT_TIME_CHANGE_ACCEPT_REMOVE_CREW, LBL_SHIFT_TIME_CHANGE_ACCEPT_NOTIFY_CREW,LBL_MARK_ABSENT, LBL_ADD, LBL_FINISH_QUOTE, LBL_SAVE_AND_CONTINUE, LBL_SAVE_AND_NEW, LBL_EXPORT_TO_PDF, LBL_BTN_ACCEPT_UNAVAILABLE_PART, LBL_BTN_ACCEPT_UNAVAILABLE_ALL} from '../../../configs/labelConfigs'; 

import {SHIFT_TIME_CHANGE_ERR_PART_UNAVAILABLE, SHIFT_TIME_CHANGE_ERR_ALL_UNAVAILABLE} from '../../../configs/staticConfigs'; 
class ModalWindow extends React.Component { 

  constructor(props){
      super()
      this.state={    
          showModal: false,
          autoFocused: false     
      }
      this.handleOpenModal  = this.handleOpenModal.bind(this);
      this.handleModelClose = this.handleModelClose.bind(this);
      this.handleModelCloseOnly = this.handleModelCloseOnly.bind(this); 
      this.handleModelCancel = this.handleModelCancel.bind(this); 
  }  

  handleOpenModal = () => {
    this.setState({
      showModal:true,
      autoFocused: false 
    });
  }

  handleModelCancel = () =>{ 
    this.setState({
      showModal:false,
      autoFocused: false    
    }, () => {
      if(this.props.type != 'imageCropper') {
          this.props.onModalCancelClick(); // USED IN CLIENT PROFILE SLIDER 
      }
    });
  }  
  
  handleModelCloseOnly = () =>{
    this.setState({
      showModal:false,
      autoFocused: false    
    });
  }  

  handleModelClose = (flag=false) =>{
      this.setState({
        showModal:false,
        autoFocused: false    
      }, () => {
        if(this.props.type != 'imageCropper'){
            this.props.resetModalForm();
        }
        // if(!flag && this.props.hasOwnProperty('selectCrewProfileId')){
        //   this.props.setSelectCrewProfileId(null);
        // }
      });
  }   

  componentDidUpdate()  { 
    if(!this.state.autoFocused && this.props.autoFocusField && this.props.autoFocusField.length > 0) {
      if(document.getElementById(this.props.autoFocusField)) {
        this.setState({autoFocused:true}); 
        document.getElementById(this.props.autoFocusField).focus(); 
      }
    }
  }

  render(){ 
    let actionButton   = '';
    let actionButtonTwo  = '';
    let cancelBtnLabel = LBL_CANCEL;
    let showDeleteLinkLeft = '';
    let showUndoDeleteLinkLeft = '';
    let noFooterButtons = ''; 
    let saveNewBtn = '';
    let approve_check_box = '';
    let save_sign_check_box = '';
    let mark_absent_check_box = '';
    let viewHeading = '';
    let sameUser = false;

    let isSaveBtnEnable = this.props.isSaveBtnEnable===undefined?true:this.props.isSaveBtnEnable;

    if(this.props.hasOwnProperty('showDeleteLinkLeft')) {
        showDeleteLinkLeft = this.props.showDeleteLinkLeft;
    }
    if(this.props.hasOwnProperty('showUndoDeleteLinkLeft')) {
        showUndoDeleteLinkLeft = this.props.showUndoDeleteLinkLeft;
    }
    if(this.props.hasOwnProperty('noFooterButtons')) {
      noFooterButtons = this.props.noFooterButtons;
    }
    if(this.props.hasOwnProperty('viewHeading')) {
      viewHeading = this.props.viewHeading;
    }
    if(this.props.hasOwnProperty('sameUser')) {
      sameUser = this.props.sameUser;
    }
    
    if(this.props.type==='AcceptTimeChange') { // FROM PROJECT SUMMARY TAG - PROJECT DETAILS SLIDER 
      actionButton = <button type="button" className="btn-danger btn btn-primary" onClick={e => this.props.acceptShiftTimeChange(e, 'REMOVECREW')}>{
        this.props?.shiftTimeChangeStaffAvailStatus==SHIFT_TIME_CHANGE_ERR_PART_UNAVAILABLE ?  LBL_BTN_ACCEPT_UNAVAILABLE_PART : 
        this.props?.shiftTimeChangeStaffAvailStatus==SHIFT_TIME_CHANGE_ERR_ALL_UNAVAILABLE ? LBL_BTN_ACCEPT_UNAVAILABLE_ALL: ''}</button>;
      // actionButton = <button type="button" className="btn-danger btn btn-primary" onClick={e => this.props.acceptShiftTimeChange(e, 'REMOVECREW')}>{LBL_SHIFT_TIME_CHANGE_ACCEPT_REMOVE_CREW}</button>;
      // actionButtonTwo = <button type="button" className="btn-danger btn btn-primary" onClick={e => this.props.acceptShiftTimeChange(e,'NOTIFYCREW')}>{LBL_SHIFT_TIME_CHANGE_ACCEPT_NOTIFY_CREW}</button>;
    }
    else if(this.props.type==='delete'){ 
      actionButton = <button type="button" className="btn-danger btn btn-primary" onClick={this.props.deleteItem}>{LBL_DELETE}</button>;
    }else if(this.props.type==='confirm'){
      actionButton = <button type="button" className="btn-danger btn btn-primary" onClick={this.props.deleteConfirmedItem}>{LBL_YES}</button>;
      cancelBtnLabel = LBL_NO; 
    }else if(this.props.type==='formSubmit'){
      actionButton = <button form="form_dataEntry" className="btn btn-primary float-right">{LBL_SAVE}</button>; 
    }
    else if(this.props.type==='updateQuote'){
      actionButton = <button type="button" className="btn btn-primary float-right" onClick={this.onSaveFormData}> &nbsp; &nbsp; {LBL_UPDATE_QUOTE} &nbsp; &nbsp; </button>; 
    }
    else if(this.props.type==='acceptQuote'){ 
      actionButton = <button type="button" className="btn btn-primary float-right" onClick={this.props.onAcceptQuote}> &nbsp; &nbsp; {LBL_ACCEPT_QUOTE} &nbsp; &nbsp; </button>; 
    }
    else if(this.props.type==='approve'){
      actionButton = <button type="button" className="btn btn-primary float-right" onClick={this.props.saveFormData} > &nbsp; &nbsp; {LBL_APPROVE} &nbsp; &nbsp; </button>;
      cancelBtnLabel = LBL_CANCEL; 
    }else if(this.props.type==='imageCropper'){
        actionButton = <button type="button" className="btn btn-primary float-right" onClick={this.props.saveFormData} > &nbsp; &nbsp; {LBL_CROP} &nbsp; &nbsp; </button>;
        cancelBtnLabel = LBL_CANCEL;
    }else if(this.props.type==='Info') {
      actionButton = <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.handleModelCloseOnly}>{LBL_OK}</button>;
    }else if(this.props.type==='EventAddSave') {
      actionButton = <button type="button" className="btn btn-primary" id="save" name="save" onClick={this.props.saveFormData} disabled={!isSaveBtnEnable}>{this.props?.saveButtonText ? this.props.saveButtonText : LBL_FINISH_QUOTE}</button>;
    }else if(this.props.type==='eventStaffDetPDFExport') { // FROM eventDetails.js
      actionButton = <button type="button" className="btn btn-primary" id="save" name="save" onClick={this.props.exportEventStaffDataPDF} disabled={!isSaveBtnEnable} >{LBL_EXPORT_TO_PDF}</button>;
      cancelBtnLabel = LBL_CANCEL;
    }else{
      actionButton = <button type="button" className="btn btn-primary" id="save" name="save" onClick={this.props.saveFormData} disabled={!isSaveBtnEnable}>{this.props?.saveButtonText ? this.props.saveButtonText : LBL_SAVE_AND_CONTINUE}</button>;
      cancelBtnLabel = LBL_CANCEL;
    }

    if(this.props.saveNew===1 && this.props.type!=='EventAddSave'){
      saveNewBtn = <button type="button" className="btn btn-primary" onClick={this.props.saveNewFormData}>{LBL_SAVE_AND_NEW}</button>;
    }

    if(this.props.saveNew===1 &&this.props.type==='EventAddSave'){
      saveNewBtn = <button type="button" className="btn btn-primary" onClick={this.props.saveNewFormData}>{LBL_ADD_ANOTHER_SHIFT}</button>;
    }
    
    if(this.props.extra_field==='approveOT'){
      approve_check_box = <div className="custom-checkbox"><input type="checkbox" id="approveOT" name="approveOT" onChange={this.props.onApproveOtChange} checked={this.props.approveChecked}/><label className="checkbox" htmlFor="approveOT"></label><label className="labeltext" htmlFor="approveOT">{LBL_APPROVE_OT}</label></div>
    }
    if(this.props.saveSign){
      save_sign_check_box = <div className="custom-checkbox"><input type="checkbox" id="saveSignChk" name="saveSignChk" onChange={(e) => this.props.saveSign(e)} /><label className="checkbox" htmlFor="saveSignChk"></label><label className="labeltext" htmlFor="saveSignChk">Save this signature</label></div>
    }
    if(this.props.mark_absent==='markAbsent'){
      mark_absent_check_box = <div className="custom-checkbox"><input type="checkbox" id="markAbsent" name="markAbsent" onChange={this.props.onMarkAbsentChange} checked={this.props.markAbsentChecked}/><label className="checkbox" htmlFor="markAbsent"></label><label className="labeltext" htmlFor="markAbsent">{LBL_MARK_ABSENT}</label></div> 
    }

    return(
      <Modal show={this.state.showModal} id={this.props.modalId} className={this.props.className?this.props.className:''} >
        <Modal.Header closeButton={false} >
            {this.props.stepper?<>{this.props.header}</>:<><h5 className="modal-title" id="addNeweventlocationLabel">{this.props.header}</h5></>}
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.props.type==='Info' ? this.handleModelCloseOnly : this.handleModelClose}>
                <span aria-hidden="true">&times;</span>
                {/* <i class="far fa-times-circle fa-lg"></i> */}
            </button>
        </Modal.Header>
        <Modal.Body className={this.props.type=="imageCropper"?"cropper-modal-body":""}>    
            {this.props.children}
        </Modal.Body>
        <Modal.Footer> 
          {/* // showDeleteLinkLeft USED IN commons/associatesComponent.js
          // noFooterButtons USED IN  event/quoteDetails.js */}
          {viewHeading !==true &&  saveNewBtn!=='' && saveNewBtn}    
          {viewHeading !==true &&  mark_absent_check_box}
          {viewHeading !==true &&  this.props.enableApprove && approve_check_box}
          {viewHeading !==true &&  save_sign_check_box} 
          {(showDeleteLinkLeft==='yes' && !sameUser) && <div className="text-red mr-auto padding-left-10"><Link className="text-red" to="#" onClick={(e) => this.props.deletePopup()}>{LBL_DELETE}</Link></div>}
          {(showUndoDeleteLinkLeft==='yes' && !sameUser) && <div className="text-red mr-auto padding-left-10"><Link className="text-blue" to="#" onClick={(e) => this.props.deleteUndoPopup()}>{LBL_UNDO_DELETE}</Link></div>}

          {viewHeading !==true &&  noFooterButtons!=='yes' && actionButton} 
          {viewHeading !==true &&  actionButtonTwo!=='' && actionButtonTwo}  
          {noFooterButtons!=='yes' && this.props.type !== 'Info' &&  
          <button type="button" className="btn btn-secondary btn-cancel" data-dismiss="modal" onClick={this.props.needOnCancel?this.handleModelCancel:this.handleModelClose}>{cancelBtnLabel}</button> }          
           
        </Modal.Footer>
      </Modal>
    )
  }

}
export default ModalWindow;